import { useEffect, useRef } from "react";
import Phaser from "phaser";
import BoardScene from "./BoardScene";
import StartScene from "./StartScene";

export default function PhaserCanvas({ onGameReady }) {
    const gameRef = useRef(null); // reference to Phaser game object
    const containerRef = useRef(null); // reference to DOM element

    useEffect(() => {
        if (!containerRef.current || gameRef.current) return;

        const config = {
            type: Phaser.AUTO,
            parent: containerRef.current,
            transparent: true,
            scale: {
                mode: Phaser.Scale.RESIZE,
                width: '100%',
                height: '100%'
            },
            scene: [StartScene, BoardScene],
        };

        const game = new Phaser.Game(config);
        gameRef.current = game;

        // pass the game instance back up to the parent component
        if (onGameReady) {
            onGameReady(game);
        }

        const canvas = game.canvas;
        if (canvas) {
            const handleWheel = (event) => {
                event.preventDefault();
                // Check if the BoardScene is active before passing the wheel event
                const boardScene = game.scene.getScene("BoardScene");
                if (boardScene && boardScene.scene.isActive()) {
                    boardScene.input.emit(Phaser.Input.Events.WHEEL, { x: event.offsetX, y: event.offsetY }, [], 0, event.deltaY, 0);
                }
            };
            canvas.addEventListener('wheel', handleWheel);

            // cleanup when component unmounts
            return () => {
                canvas.removeEventListener('wheel', handleWheel);
                if (gameRef.current) {
                    gameRef.current.destroy(true);
                    gameRef.current = null;
                }
            };
        }

        // cleanup when component unmounts
        return () => {
            if (gameRef.current) {
                gameRef.current.destroy(true);
                gameRef.current = null;
            }
        };
    }, [onGameReady]);

    return (
        <div
            ref={containerRef}
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundImage: 'url(/assets/woodBG2.png)',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat'
            }}
        />
    );
}